import { useTranslation } from "react-i18next";

import { DeviceInIcon, DeviceOutIcon } from "@dotnet/telematics-design-system";

import Button, {
    BUTTON_COLORS,
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "components/DesignComponents/Button";
import Dialog from "components/DesignComponents/Dialog";
import { useMediaQueries } from "shared";

import { DeviceTransferModalProps, TRANSFER_DEVICE_WINDOWS } from "../../types";

const MainScreen = ({
    isOpen,
    modalCSS,
    close,
    changeDialogWindow,
    changeBackdrop
}: DeviceTransferModalProps) => {
    const { t } = useTranslation();

    const { toMd } = useMediaQueries();

    return (
        <Dialog
            data-testid="transfer-devices-main-screen"
            title={t("Dialog##device transfer##main##title")}
            description={t("Dialog##device transfer##main##description")}
            isActionsSeparator
            open={isOpen}
            close={close}
            actions={
                <>
                    <Button
                        data-testid="switch-to-transfer-devices"
                        fullWidth
                        color={BUTTON_COLORS.PrimarySubtle}
                        size={BUTTON_SIZES.Normal}
                        variant={BUTTON_VARIANTS.IconLeft}
                        icon={<DeviceOutIcon />}
                        onClick={() =>
                            changeDialogWindow(
                                TRANSFER_DEVICE_WINDOWS.TransferDevices
                            )
                        }
                    >
                        {t("Button##transfer my devices")}
                    </Button>

                    <Button
                        data-testid="switch-to-receive-devices"
                        fullWidth
                        color={BUTTON_COLORS.PrimarySubtle}
                        size={BUTTON_SIZES.Normal}
                        variant={BUTTON_VARIANTS.IconLeft}
                        icon={<DeviceInIcon />}
                        onClick={() =>
                            changeDialogWindow(
                                TRANSFER_DEVICE_WINDOWS.ReceiveDevices
                            )
                        }
                    >
                        {t("Button##receive devices")}
                    </Button>
                </>
            }
            css={modalCSS}
            extendToMaxWidth={toMd}
            slotProps={{
                transition: {
                    onEntered: () => changeBackdrop?.("none !important")
                }
            }}
        />
    );
};
export default MainScreen;
